"use client"
import { ComponentConfig } from "@measured/puck"
import { MediaSelect } from "../../../../media/pages/SelectMediaUIBuilder"
import { commonStylesProps } from "../../lib/commonCSSProps"
import getClassNameFactory from "../../lib/get-class-name-factory"
import { ImageProps, RenderConfig } from "./RenderConfig"
import styles from "./styles.module.css"

const getClassName = getClassNameFactory("Image", styles)

export const Image: ComponentConfig<ImageProps> = {
  label: "Image",
  //@ts-ignore
  fields: {
    imageUrl: {
      label: "Image",
      type: "custom",
      render: props => <MediaSelect {...props} />,
    },
    link: {
      label: "Link",
      type: "text",
    },
    // Size fields are grouped per breakpoint (width above height) so the pair an editor
    // sets together sits together. Prop keys are unchanged — renaming would break saved JSON.
    widthDesktop: { label: "Desktop — Width", type: "text" },
    heightStyle: { label: "Desktop — Height", type: "text" },
    widthTablet: { label: "Tablet — Width", type: "text" },
    heightTablet: { label: "Tablet — Height", type: "text" },
    witdhMobile: { label: "Mobile — Width", type: "text" },
    heightMobile: { label: "Mobile — Height", type: "text" },
    borderRadius: { label: "Border Radius", type: "text" },
    padding: { label: "Padding", type: "text" },
    margin: { label: "Margin", type: "text" },
    border: { label: "Border", type: "text" },
    multiple: {
      label: "Multiple",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    objectFit: {
      label: "Object Fit",
      type: "select",
      options: [
        {
          label: "Cover",
          value: "cover",
        },
        {
          label: "Contain",
          value: "contain",
        },
        {
          label: "Fill",
          value: "fill",
        },
        {
          label: "None",
          value: "none",
        },
        {
          label: "Scale Down",
          value: "scale-down",
        },
      ],
    },
    objectPosition: {
      label: "Object Position",
      type: "select",
      options: [
        { label: "Center", value: "center" },
        { label: "Top", value: "top" },
        { label: "Bottom", value: "bottom" },
        { label: "Left", value: "left" },
        { label: "Right", value: "right" },
        { label: "Top Left", value: "top-left" },
        { label: "Top Right", value: "top-right" },
        { label: "Bottom Left", value: "bottom-left" },
        { label: "Bottom Right", value: "bottom-right" },
      ],
    },

    ...commonStylesProps, // Include common CSS props
  },
  defaultProps: {
    padding: "0px",
    heightStyle: "auto",
    witdhMobile: "100%",
    borderRadius: "0px",
    border: "0px",
    multiple: false,
    objectFit: "cover",
    objectPosition: "center",
    className: "",
  },
  ...RenderConfig,
}
